import { render } from "./NotSubmittedDataDialog.vue?vue&type=template&id=31896e20&ts=true"
import script from "./NotSubmittedDataDialog.vue?vue&type=script&lang=ts"
export * from "./NotSubmittedDataDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__